/* eslint-disable linebreak-style */
import React from 'react';
const DisasterAssistanceHardshipStepShared = () => (
  <ol>
    <li>
    Provide proof of loss to Primary Residence, from your home insurance or state/Federal aid agency
    </li>
    <li>
    Proof of Outstanding Dues (invoice or other documentation received from developer)
    </li>
    <li>
    Drivers License/ID Card
    </li>
  </ol>
);

export default DisasterAssistanceHardshipStepShared;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.DuesProtect.DisasterAssistanceHardshipStep/components/DisasterAssistanceHardshipStepShared.js